import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

/**
 * AnalyticsTracker — fires an anonymous POST /api/analytics/track on every
 * route change. Skips admin routes so we only measure customer-facing traffic.
 */
export default function AnalyticsTracker() {
  const loc = useLocation();
  const lastRef = useRef(null);
  useEffect(() => {
    const path = loc.pathname + (loc.search || "");
    if (path.startsWith("/admin")) return;
    if (lastRef.current === path) return; // avoid duplicate on Strict Mode double-effect
    lastRef.current = path;
    const sid = (() => {
      try {
        let s = localStorage.getItem("adiyogi_sid");
        if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("adiyogi_sid", s); }
        return s;
      } catch { return ""; }
    })();
    api.post("/analytics/track", {
      path,
      referrer: document.referrer || "",
      session_id: sid,
    }).catch(() => {});
  }, [loc.pathname, loc.search]);
  return null;
}
